/**
 * `/onboarding` and `/setup` — old first-run addresses, kept as redirects.
 * (Citizen first run · Citizen Home)
 *
 * Neither screen exists any more: a new citizen lands on Home, which tells the
 * story and the five steps, and where a company journey needs the citizen's
 * residence it is asked in place. But both addresses are still out there — in
 * Clerk's configured redirects, old e-mails and bookmarks, a tab left open —
 * so this is the ONE place that decides where each of those arrivals belongs:
 *
 *   - an old wizard edit link (`?edit=true&step=…`) → the matching profile
 *     section (the wizard's steps are optional sections of Settings → Profile);
 *   - anything else → `?next=` when it is a safe in-app path, or Home.
 */
import { Redirect } from 'wouter';

// The pure link rules only — not the barrel, which would pull the profile forms
// into the eagerly-loaded route table.
import {
  profileSectionHref,
  sectionForLegacyStep,
} from '@/features/secondary/profile-sections/lib/profile-sections';

import { safeInternalNext } from '../lib/safe-next';

/** Where an arrival on an old first-run address belongs now. */
export function legacyFirstRunDestination(search: string): string {
  const params = new URLSearchParams(search);
  if (params.get('edit') === 'true') {
    return profileSectionHref(sectionForLegacyStep(params.get('step')));
  }
  return safeInternalNext(params.get('next')) ?? '/dashboard';
}

export function LegacyFirstRunRedirect() {
  const search = typeof window === 'undefined' ? '' : window.location.search;
  return <Redirect to={legacyFirstRunDestination(search)} replace />;
}
